import Vue from "vue";
import VueSmartWidget from "vue-smart-widget";

Vue.use(VueSmartWidget);
